import {Component, ElementRef, OnInit} from '@angular/core';
import {
  Photo,
  PhotoGallerySettings
} from '../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';
import {
  Animal,
  Rarity,
  Entry,
  Entries
} from '../../../widgets-module/components/animal-rarities/animal-rarities-classes';
import {TripEntry} from '../../../widgets-module/components/trip-list/trip-list.component';
import {LazyLoaderService} from "../../../../core/services/lazy-loader/lazy-loader.service";
import {NationalParkService} from "../../../widgets-module/national-park.service";
import {Park, Point} from "../../../../google-maps-points";
import {IraqwText} from "./iraqw-culture-center.text";

@Component({
  selector: 'app-iraqw-culture-center',
  templateUrl: './iraqw-culture-center.component.html',
  styleUrls: ['./iraqw-culture-center.component.css']
})
export class IraqwCultureCenterComponent implements OnInit {

  tripEntries: TripEntry[] = [
    new TripEntry({title: 'Culture Quest Safari', route: '../../safari/culture-quest-safari', iconName: 'drum'})
  ];

  mapLat = -3.3280134;
  mapLng = 35.632044;
  strokeWeight = 5;
  zoom = 9; // default zoom level of the map


  animalEntries: Entries = new Entries({
    entries:
      [
        new Entry({animal: Animal.Lion, rarity: Rarity.Common}),
        new Entry({animal: Animal.Elephant, rarity: Rarity.Common}),
        new Entry({animal: Animal.Baboon, rarity: Rarity.Common}),
        new Entry({animal: Animal.Giraffe, rarity: Rarity.Common}),
        new Entry({animal: Animal.Cheetah, rarity: Rarity.Common}),
        new Entry({animal: Animal.Warthog, rarity: Rarity.Common}),
        new Entry({animal: Animal.Zebra, rarity: Rarity.Common}),
        new Entry({animal: Animal.Jackal, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.EgyptianDuck, rarity: Rarity.Uncommon}),
        new Entry({animal: Animal.BlackRhino, rarity: Rarity.Rare})
      ]
  });

  circleWidthsDesktop = ['3rem', '4.25rem', '5.25rem'];
  circleWidthsMobile = ['3.5rem', '5rem', '6.25rem'];


  footprintGallery: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Iraqw Woman Crafting Jewelry',
          description: 'An Iraqw woman rests and beads together jewelry.',
          thumbnailPath: 'others/iraqw-woman-beading.jpg',
          highresPath: '../../assets/img/others/iraqw-woman-beading.jpg',
          altPhotoDescription: 'An Iraqw woman rests and beads together jewelry.'
        })
      ]
  });
  plainsGallery: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Iraqw Home Construction',
          description: 'The Iraqw people construct their own homes out of clay mud bricks. This is setting the foundation for a basement.',
          thumbnailPath: '1920x1080/iraqw-bricks.jpg',
          highresPath: '../../assets/img/1920x1080/iraqw-bricks.jpg',
          altPhotoDescription: 'The Iraqw Culture Center is centered in Karatu, which is nearby the Ngorongoro Conservation Area.'
        })
      ]
  });
  iraqwHomePhoto: PhotoGallerySettings = new PhotoGallerySettings({
    iconColor: 'dark',
    photos:
      [
        new Photo({
          title: 'Traditional Iraqw Home',
          description: 'Traditionally, Iraqw homes are built with woven sticks, and mud. <br/><br/>' +
            'Each family may own multiple homes for themselves and their cattle. ',
          thumbnailPath: 'others/traditional-iraqw-home.jpg',
          highresPath: '../../assets/img/others/traditional-iraqw-home.jpg',
          altPhotoDescription: 'A traditional Iraqw home.'
        })
      ]
  });

  parkBoundaries = [
    new Park({
      name: 'Iraqw Culture Center',
      contentId: '/national-parks/iraqw-culture-center',
      defaultColor: '#e14658',
      hoverColor: '#AD9F00',
      tooltipOrigin: new Point({lng: 35.38507607, lat: -2.8895554}),
      points:
        [
          new Point({lng: 35.34889698, lat: -3.11966968}),
          new Point({lng: 35.33250332, lat: -3.06929854}),
          new Point({lng: 35.32907009, lat: -2.92198451}),
          new Point({lng: 35.33001423, lat: -2.90687012}),
          new Point({lng: 35.37370350, lat: -2.88955542}),
          new Point({lng: 35.40777828, lat: -2.90069857}),
          new Point({lng: 35.43958073, lat: -3.05698431}),
          new Point({lng: 35.35868168, lat: -3.11366986})
        ]
    })
  ];

  parkText = new IraqwText();

  constructor( private lazyLoader: LazyLoaderService,
               private elementRef: ElementRef,
               private parkService: NationalParkService) {
  }

  // onLoadHotelCubes(callback) {
  //   this.lazyLoader.load('app-hotel-cubes').then(componentEl => {
  //     componentEl['currentPage'] = this.parkId;
  //     this.elementRef.nativeElement
  //       .querySelector('#hotel-cubes-container')
  //       .appendChild(componentEl);
  //     callback.apply();
  //   });
  // }



  ngOnInit() {
    // this.onLoadHotelCubes(() => {
    //   this.parkService.setCurrentParkPage(this.parkId, () => {
    //     this.parkService.removeCurrentPageParkCube();
    //   });
    // });
  }

  isMobile() {
    return document.body.clientWidth < 991.98 && document.body.clientWidth > 767.98;
  }

  isMobileBr() {
    return document.body.clientWidth < 500;
  }

}
